import type { Environment } from './environment.interface';

const BACKEND_DOMAIN = 'https://api-staging.datanyze.com';
const ASSETS_DOMAIN = 'https://assets.datanyze.com';

export const environment: Environment = {
  production: false,
  name: 'staging',
  backend_domain: BACKEND_DOMAIN,
  website_url: 'https://www-staging.datanyze.com',
  platform_url: 'https://app-staging.datanyze.com',
  identity_backend_url: `${BACKEND_DOMAIN}/identity`,
  images_url: `${ASSETS_DOMAIN}/images`,
  icons_url: `${ASSETS_DOMAIN}/icons`,
  stripe_backend_url: `${BACKEND_DOMAIN}/stripe`,
  payment_providers_backend_url: `${BACKEND_DOMAIN}/payment-providers`,
  payment_backend_url: `${BACKEND_DOMAIN}/payment`,
  config_backend_url: `${BACKEND_DOMAIN}/config`,
  GOOGLE_TAG_MANAGER_ID: 'GTM-MQCTMBN',
  SALESFORCE_CAMP_ID: {
    goTo_signup: '7014y000001t6UxAAI',
  },
  auth_cookie: 'dn-tk-stg',
  deviceId_cookie: 'deviceId-stg',
  verification_id_cookie: 'dn-verification-id-stg',

  // Constants moved from ConstantsService
  DATANYZE_COOKIE_DOMAIN: '.datanyze.com',
  GOOGLE_ANALYTIC_SECTION: 'website',
  SF_CAMP_ID: 'camp_id',
  REDIRECT_KEY: 'redirect',
  SKIPCAPTCHA_KEY: 'skipcaptcha',
  GA_COOKIE_FETCH_RETRIES: 3,
  GTM_COOKIE_NAME: '_ga',
  GA_COOKIE_FETCH_INTERVAL: 2000,
  GOOGLE_OPTIMIZE_SCRIPT: 'https://www.googleoptimize.com/optimize.js?id=OPT-K5F7LKW',
  COOKIE_CONSENT_COOKIE_NAME: 'CookieConsent',
  RANDOM_ID_KEY: 'staging-user-session-id',
};
